export default "__VITE_ASSET__CxOcrgN5__"